/* unplugin-vue-components disabled */import script from "./role-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./role-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./role-dialog.vue?vue&type=style&index=0&id=0a4867ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4867ec"]])

export default __exports__